export default __webpack_public_path__ + "static/font-e67ba6ec1cd68ac50f88ecb332c05e86.woff2";